import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { ParseTbmQrValue } from './TbmJoinUrl';
import { SetPendingTbmJoinToken } from './TbmDeepLink';

const JOIN_PATH = '/tbm/join/';

/** 앱이 열린 URL이 TBM 입장 링크면 토큰을, 아니면 '' (본인인증 등 다른 링크는 무시) */
const ExtractJoinToken = (url) =>
  String(url ?? '').includes(JOIN_PATH) ? ParseTbmQrValue(url) : '';

/** 네이티브 앱 전용: TBM 입장 링크로 앱이 열리면 홈으로 보내 회원 참석 처리 */
function TbmLinkHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    const handleUrl = (url) => {
      const token = ExtractJoinToken(url);
      if (!token) return;
      SetPendingTbmJoinToken(token);
      navigate('/Home', { replace: true });
    };

    // 앱이 꺼진 상태에서 링크로 시작된 경우
    CapacitorApp.getLaunchUrl()
      .then((launch) => handleUrl(launch?.url))
      .catch(console.error);

    // 앱이 켜져 있는 상태에서 링크를 연 경우
    let handle;
    let disposed = false;
    CapacitorApp.addListener('appUrlOpen', (event) => handleUrl(event.url)).then(
      (h) => {
        if (disposed) h.remove();
        else handle = h;
      }
    );

    return () => {
      disposed = true;
      handle?.remove();
    };
  }, [navigate]);

  return null;
}

export default TbmLinkHandler;
